<template>
  <div id='loading'>
    <div id='animation-default'>
      <svg width='105' height='105' viewBox='0 0 105 105' xmlns='http://www.w3.org/2000/svg' fill='#aab7d9' class='color-loading'>
        <circle cx='12.5' cy='12.5' r='12.5'>
          <animate attributeName='fill-opacity' begin='0s' dur='1s' values='1.21' calcMode='linear' repeatCount='indefinite' />
        </circle>
        <circle cx='12.5' cy='52.5' r='12.5' fill-opacity='.5'>
          <animate attributeName='fill-opacity' begin='100ms' dur='1s' values='1.21' calcMode='linear' repeatCount='indefinite' />
        </circle>
        <circle cx='52.5' cy='12.5' r='12.5'>
          <animate attributeName='fill-opacity' begin='300ms' dur='1s' values='1.21' calcMode='linear' repeatCount='indefinite' />
        </circle>
        <circle cx='52.5' cy='52.5' r='12.5'>
          <animate attributeName='fill-opacity' begin='600ms' dur='1s' values='1.21' calcMode='linear' repeatCount='indefinite' />
        </circle>
        <circle cx='92.5' cy='12.5' r='12.5'>
          <animate attributeName='fill-opacity' begin='800ms' dur='1s' values='1.21' calcMode='linear' repeatCount='indefinite' />
        </circle>
        <circle cx='92.5' cy='52.5' r='12.5'>
          <animate attributeName='fill-opacity' begin='400ms' dur='1s' values='1.21' calcMode='linear' repeatCount='indefinite' />
        </circle>
        <circle cx='12.5' cy='92.5' r='12.5'>
          <animate attributeName='fill-opacity' begin='700ms' dur='1s' values='1.21' calcMode='linear' repeatCount='indefinite' />
        </circle>
        <circle cx='52.5' cy='92.5' r='12.5'>
          <animate attributeName='fill-opacity' begin='500ms' dur='1s' values='1.21' calcMode='linear' repeatCount='indefinite' />
        </circle>
        <circle cx='92.5' cy='92.5' r='12.5'>
          <animate attributeName='fill-opacity' begin='200ms' dur='1s' values='1.21' calcMode='linear' repeatCount='indefinite' />
        </circle>
      </svg>
      <h1>Buscando</h1>
      <h1 style='margin-top: 0px'>Contemplados</h1>

    </div>

    <div id='animation-dot'>
      <div class='container-dot'>
        <div class='dot dot-1 color1'></div>
        <div class='dot dot-2 color2'></div>
        <div class='dot dot-3 color3'></div>
      </div>
      <svg xmlns='http://www.w3.org/2000/svg' version='1.1'>
        <defs>
          <filter id='goo'>
            <feGaussianBlur in='SourceGraphic' stdDeviation='10' result='blur' />
            <feColorMatrix in='blur' mode='matrix' values='1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 21 -7'/>
          </filter>
        </defs>
      </svg>
      <h1>Buscando</h1>
      <h1 style='margin-top: 0px'>Contemplados</h1>
    </div>
  </div>
</template>

<script>
export default {
  name: 'loading-animation',

  mounted () {
    $('#animation-default').css('display', 'none')
    $('#animation-dot').css('display', 'block')
  }
}
</script>
<style scoped>
.color-loading {
  background: none;
}
</style>



// WEBPACK FOOTER //
// src/components/LoadingAnimation.vue